import { faHeart as faHeartLight } from "@jewlr/pro-light-svg-icons/faHeart"
import { faSpinner } from "@jewlr/pro-regular-svg-icons/faSpinner"
import { faHeart as faHeartSolid } from "@jewlr/pro-solid-svg-icons/faHeart"
import PropTypes from "prop-types"
import { useEffect, useState } from "react"

import withWishlist from "areas/collection/hoc/with-wishlist"
import { openModal } from "components/modal"
import Button from "components/ui/button"
import FontAwesomeIcon from "components/ui/font-awesome-icon"
import { IS_JEWLR, isTestMode } from "helpers/application"
import { cn } from "styles/utils"

const WishlistIcon = ({
  confirmWishlist,
  isLoggedIn,
  setProductParams,
  toggleAddToWishlist,
  wishlistAdded,
  wishlistLoading,
}) => {
  const [loading, setLoading] = useState(false)

  const wishlistName = IS_JEWLR() ? "wish list" : "collection"
  const ariaLabel = loading
    ? `Loading ${wishlistName}`
    : isLoggedIn
      ? wishlistAdded
        ? `Remove from ${wishlistName}`
        : `Add to ${wishlistName}`
      : `Create a VIP account to add to your ${wishlistName}`

  useEffect(() => {
    if (!wishlistLoading) {
      setLoading(wishlistLoading)
    }
  }, [wishlistLoading])

  return (
    <Button
      aria-label={ariaLabel}
      className="z-1 desktop:right-20 desktop:top-20 absolute right-8 top-8"
      disabled={loading}
      id="col_add_to_wishlist"
      onClick={(e) => {
        if (!isTestMode) {
          dataLayer.push({ event: "clicked-wishlist-icon" })
        }

        if (!IS_JEWLR() || isLoggedIn) {
          if (!loading) {
            setLoading(true)
            toggleAddToWishlist(
              confirmWishlist,
              setProductParams,
              e,
              setLoading
            )
          }
        } else {
          openModal("#signup")
        }
      }}
      title={ariaLabel}
    >
      {loading ? (
        <FontAwesomeIcon className="text-16" icon={faSpinner} spin />
      ) : (
        <FontAwesomeIcon
          className={cn(
            "text-18 desktop:text-20",
            wishlistAdded ? "text-wishlist" : "text-black"
          )}
          icon={wishlistAdded ? faHeartSolid : faHeartLight}
        />
      )}
    </Button>
  )
}

WishlistIcon.propTypes = {
  confirmWishlist: PropTypes.func,
  isLoggedIn: PropTypes.bool,
  setProductParams: PropTypes.func,
  toggleAddToWishlist: PropTypes.func,
  wishlistAdded: PropTypes.bool,
  wishlistLoading: PropTypes.bool,
}

export default withWishlist(WishlistIcon)
